import { deleteAnnouncementApi } from '@eastcoal/api/trade/announcementOperation/deleteAnnouncement'

import { ConfirmButton } from '@eastcoal/common/components/Button/ConfirmButton'
import { useRemoteTableStore } from '@eastcoal/common/components/RemoteTable/Store/hooks/useStore'
import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { AnnouncementDeleteButtonProps } from './interface'

export const AnnouncementDeleteButton = ({
  uuid,
  record
}: AnnouncementDeleteButtonProps) => {
  const { message } = useFeedback()
  const { reload } = useRemoteTableStore(state => pick(state, ['reload']))

  const handleConfirm = async () => {
    await deleteAnnouncementApi({
      ids: [record.id as string]
    })
    message.success('删除成功')
    reload()
  }

  return (
    <ConfirmButton
      danger
      message='确定删除吗？'
      placement='leftBottom'
      type='link'
      uuid={uuid}
      onConfirm={handleConfirm}
    >
      删除
    </ConfirmButton>
  )
}
